import AxiosService from '../../../gateway/rest/AxiosService'

class MssqlPolicyRestService {
  static async getStatus(): Promise<any> {
    return AxiosService.get('/adaptermssql/policy/getStatus')
  }
  static async applyPolicy(): Promise<any> {
    return AxiosService.post('/adaptermssql/policy/apply')
  }
  static async unapplyPolicy(): Promise<any> {
    return AxiosService.post('/adaptermssql/policy/unapply')
  }
}

export default MssqlPolicyRestService
